"use client";

import { usePathname } from "next/navigation";
import { useReportWebVitals } from "next/web-vitals";

// Field data for the Performance tab of /admin/analytics.
//
// useReportWebVitals is part of the Next runtime — the web-vitals library is
// already bundled inside Next — so this adds no new bytes to the page. Reports
// arrive after the measurement they describe, and sendBeacon hands the payload
// to the browser to deliver on its own schedule, so measuring the page never
// competes with rendering it.

const ENDPOINT = "/api/vitals";

const WebVitals = () => {
  const pathname = usePathname();

  useReportWebVitals((metric) => {
    // Admin traffic is us, not the audience — it would skew every percentile
    // on the dashboard that reads it.
    if (!pathname || pathname.startsWith("/admin")) return;

    const payload = JSON.stringify({
      name: metric.name,
      value: metric.value,
      rating: metric.rating,
      path: pathname,
    });

    try {
      if (navigator?.sendBeacon) {
        navigator.sendBeacon(
          ENDPOINT,
          new Blob([payload], { type: "application/json" }),
        );
        return;
      }
      fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: payload,
        keepalive: true,
      }).catch(() => {});
    } catch {
      // Never let instrumentation break the page it is instrumenting.
    }
  });

  return null;
};

export default WebVitals;
